let queue = [];
let timeout = null;
const BATCH_DELAY = 2000; // 2 seconds

export const bufferEvent = (event, createEventMutation) => {
    queue.push(event);

    if (timeout) {
        clearTimeout(timeout);
    }

    timeout = setTimeout(async () => {
        if (queue.length > 0) {
            const batch = [...queue];
            queue = [];
            try {
                await createEventMutation(batch).unwrap();
            } catch (err) {
                console.error('Failed to send event batch:', err);
            }
        }
        timeout = null;
    }, BATCH_DELAY);
};
